import type { PollManager } from './PollManager';

/**
 * Dispose poll manager and clear existing data.
 */
export function dispose(manager: PollManager): void {
  manager.log.info('Disposing manager');

  manager.disposeSubscribers();

  manager.rootRef = null;
  manager.pollListRef = null;
  manager.pollActiveMetaRef = null;

  manager.setContext({
    activePollId: null,
    polls: {},
  });
}
